import { EmailFromType } from '@enums/email-from-type.enum';

export interface EmailFromJson {
  email: string;
  name: string;
  type: EmailFromType;
  phone_number?: string;
}

export class EmailFrom {
  constructor(
    public email: string,
    public name: string,
    public type: EmailFromType,
    public phoneNumber?: string
  ) {}

  static fromJson(json: EmailFromJson): EmailFrom {
    return new EmailFrom(json.email, json.name, json.type, json.phone_number);
  }

  static toJson(data: EmailFrom): EmailFromJson {
    return {
      email: data.email,
      name: data.name,
      type: data.type,
      phone_number: data.phoneNumber
    };
  }
}
